/**
 * API Error Handling
 * Centralized error normalization for consistent error handling across the app
 */

/**
 * Converts various error types to normalized ApiError
 * Handles @wix/http-client errors and other error types
 */
export function toApiError(error) {
  const timestamp = new Date().toISOString();

  // Handle @wix/http-client response errors
  if (error != null && error.response) {
    var _response$data, _response$data2, _response$data3, _response$data4;
    const {
      response
    } = error;
    return {
      status: response.status ?? null,
      code: ((_response$data = response.data) == null ? void 0 : _response$data.code) || ((_response$data2 = response.data) == null ? void 0 : _response$data2.errorCode),
      message: ((_response$data3 = response.data) == null ? void 0 : _response$data3.message) || ((_response$data4 = response.data) == null ? void 0 : _response$data4.errorMessage) || `Request failed with status ${response.status}`,
      details: response.data,
      timestamp
    };
  }

  // Handle network errors (no response)
  if (error != null && error.request) {
    return {
      status: null,
      message: 'Network error - please check your connection',
      details: {
        originalError: error.message
      },
      timestamp
    };
  }

  // Handle other errors (validation, etc.)
  return {
    status: null,
    message: (error == null ? void 0 : error.message) || 'An unexpected error occurred',
    details: {
      originalError: error
    },
    timestamp
  };
}

/**
 * Type guard to check if an error is an ApiError
 */
export function isApiError(error) {
  return error && typeof error === 'object' && typeof error.message === 'string';
}

/**
 * Check if error is a specific HTTP status
 */
export function isErrorStatus(error, status) {
  return isApiError(error) && error.status === status;
}

/**
 * Check if error is unauthorized (401)
 */
export function isUnauthorizedError(error) {
  return isErrorStatus(error, 401);
}

/**
 * Check if error is forbidden (403)
 */
export function isForbiddenError(error) {
  return isErrorStatus(error, 403);
}

/**
 * Check if error is not found (404)
 */
export function isNotFoundError(error) {
  return isErrorStatus(error, 404);
}

/**
 * Check if error is a server error (5xx)
 */
export function isServerError(error) {
  return isApiError(error) && error.status !== null && error.status >= 500;
}
//# sourceMappingURL=error.js.map